import Container from "../../components/ui/Container.js"
import "./CrosswordView.scss"

import { useSteps } from "../../hooks/useSteps"
import { useState } from "react"

import { ModalGanaste } from "../../components/games/ModalGanaste"
import { GoBackBtn } from "../../components/games/GoBackBtn"

import Memory from "../../components/games/memory/Memory"
import { ElegirTag } from "../../components/games/ElegirTag.js"
import { useTranslation } from "react-i18next"

const ElegirDificultad = ({ hasImages = false, setDificultad }) => {
  const dificultades = [
    hasImages ? "img" : null,
    "a4x4",
    "a5x4",
    "a6x4",
  ].filter((element) => element !== null)

  const { t } = useTranslation()

  const handleClick = (code) => {
    setDificultad(code)
  }

  return (
    <>
      <div className="title">{t(`ui.games.headers.choose_a_difficulty`)}</div>
      <div id="category-container" className="container-sm container-mini">
        <div className="row">
          {dificultades.map((code) => (
            <div key={code} className="col-lg-4 col-6 py-1">
              <div className="box category" onClick={() => handleClick(code)}>
                <span>
                  <b>{t(`games.memory.difficulties.${code}.name`)}</b>
                </span>
                <span style={{ textAlign: "center" }}>
                  {t(`games.memory.difficulties.${code}.title`)}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

const MemoryView = () => {
  let [steps] = useSteps(["categoria", "dificultad", "images"]),
    setCategoria = steps.setter("categoria"),
    setDificultad = steps.setter("dificultad"),
    setImages = steps.setter("images")

  const showModalGanaste = useState(false),
    handleWin = () => showModalGanaste[1](true)

  return (
    <Container>
      <div className="memory-game">
        <ModalGanaste show={showModalGanaste} steps={steps} />
        <div className="steps-bt">
          <GoBackBtn steps={steps} />
        </div>

        {steps.at("categoria") && (
          <ElegirTag setTag={setCategoria} setHasImages={setImages} />
        )}

        {steps.at("dificultad") && (
          <ElegirDificultad
            hasImages={steps.data.images}
            setDificultad={setDificultad}
          />
        )}

        {steps.done && (
          <Memory
            category={steps.data.categoria}
            difficulty={steps.data.dificultad}
            winCallback={handleWin}
          />
        )}
      </div>
    </Container>
  )
}

export default MemoryView
